// Chakra imports
import { Flex, Icon, Text, useColorModeValue } from "@chakra-ui/react";
// Custom components
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardHeader from "components/Card/CardHeader.js";
import TransactionRow from "components/Tables/TransactionRow";
import React from "react";
import { FaRegCalendarAlt } from "react-icons/fa";
import Skeleton from "react-loading-skeleton"; // Import Skeleton
import 'react-loading-skeleton/dist/skeleton.css'; // Import skeleton styles

const Transactions = ({
  title,
  date,
  newestTransactions = [],
  olderTransactions = [],
  isLoading, // New prop to indicate loading state
}) => {
  // Chakra color mode
  const textColor = useColorModeValue("gray.700", "white");

  return (
    <Card my='24px' ms={{ lg: "24px" }}>
      <CardHeader mb='12px'>
        <Flex direction='column' w='100%'>
          <Flex
            direction={{ sm: "column", lg: "row" }}
            justify={{ sm: "center", lg: "space-between" }}
            align={{ sm: "center" }}
            w='100%'
            my={{ md: "12px" }}
          >
            {isLoading ? (
              <Skeleton width="200px" height="24px" />
            ) : (
              <Text
                color={textColor}
                fontSize={{ sm: "lg", md: "xl", lg: "lg" }}
                fontWeight='bold'
              >
                {title}
              </Text>
            )}
            <Flex align='center'>
              <Icon
                as={FaRegCalendarAlt}
                color='gray.400'
                fontSize='md'
                me='6px'
              ></Icon>
              {isLoading ? (
                <Skeleton width="100px" height="20px" />
              ) : (
                <Text color='gray.400' fontSize='sm' fontWeight='semibold'>
                  {date}
                </Text>
              )}
            </Flex>
          </Flex>
        </Flex>
      </CardHeader>
      <CardBody>
        <Flex direction='column' w='100%'>
          <Text
            color='gray.400'
            fontSize={{ sm: "sm", md: "md" }}
            fontWeight='semibold'
            my='12px'
          >
            NEWEST
          </Text>
          {isLoading ? (
            Array(3).fill().map((_, index) => (
              <Skeleton key={index} height="50px" style={{ marginBottom: '8px' }} />
            ))
          ) : (
            newestTransactions.map((row) => {
              return (
                <TransactionRow
                  key={row.name} // Add a unique key
                  name={row.name}
                  logo={row.logo}
                  date={row.date}
                  price={row.price}
                />
              );
            })
          )}
          <Text
            color='gray.400'
            fontSize={{ sm: "sm", md: "md" }}
            fontWeight='semibold'
            my='12px'
          >
            OLDER
          </Text>
          {isLoading ? (
            Array(3).fill().map((_, index) => (
              <Skeleton key={index} height="50px" style={{ marginBottom: '8px' }} />
            ))
          ) : (
            olderTransactions.map((row) => {
              return (
                <TransactionRow
                  key={row.name} // Add a unique key
                  name={row.name}
                  logo={row.logo}
                  date={row.date}
                  price={row.price}
                />
              );
            })
          )}
        </Flex>
      </CardBody>
    </Card>
  );
};

export default Transactions;
